import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Label,
  TextArea,
  Dropdown,
  Input,
  Icon,
  Checkbox
} from 'semantic-ui-react'

const CardImagingResultUX = (props: any) => {
    return(
      <div
        id="CardImagingResultUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          id="CardImagingResultUX-div-1">

          <div
            id="CardImagingResult-Div-ImagingOrderListScreen"
            style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>

            <div
              id="CardImagingResultUX-div-6"
              style={{fontSize: "1.1rem", fontWeight: "bold", padding: "2.5px 0"}}>
              {props.languageUX === "en" ? "Imaging Order List" : "รายการสั่งซื้อการถ่ายภาพ"}
            </div>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardImagingResultUX-div-2"
          style={{marginTop: "0.5rem"}}>

        </div>
        <div
          className="ui form"
          id="CardImagingResultUX-div-4">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.imagingOrderList || []}
            getTrProps={props.onGetTrProps}
            headers={`Orderdate/Time,Order No.,Imaging Type,Request,Item Status,Careprovider,Radiologistt${ props.hideColumnResult ? "" : ",Result"},Log`}
            id="CardImagingResultUX-Table-15"
            keys={`datetime,order_no,type, request, order_status, doctor_name,radiologist${props.hideColumnResult ? "" : ",result"}, log`}
            minRows={11}
            showPagination={false}
            style={{height: !!props.selectedOrder? "195px": props.tableHeight? props.tableHeight :"calc(100vh - 14rem)"}}
            widths={`120,120,^120,^250,^100,^120,^120${props.hideColumnResult ? "" : ",70"},70`}>
          </Table>
        </div>
        <div
          id="CardImagingResultUX-div-16"
          style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
          {props.pagination}
        </div>
        <div
          className={`ui form ${props.readOnly ? "--override-disabled" : ""}`}
          id="CardImagingResultUX-div-17"
          style={{marginTop: "1.5rem", display: !!props.selectedOrder?"":"none"}}>

          <FormGroup
            id="CardImagingResultUX-FormGroup-18"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-25"
              inline={true}>
              <label
                id="CardImagingResultUX-label-32"
                style={{fontSize: "1.1rem"}}>
                {props.languageUX === "en" ? "Imaging Result Entry" : "การป้อนผลลัพธ์การถ่ายภาพ"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-101"
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-102">
              <Icon
                className="red large"
                id="CardImagingResultUX-Icon-103"
                link={true}
                name="close"
                onClick={props.onClose}>
              </Icon>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-19"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-26"
              inline={true}>
              <label
                id="CardImagingResultUX-label-33"
                style={{fontSize: "1.1rem", color: "#2185D0"}}>
                {props.selectedOrder?.group_name|| "-"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-20"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-27"
              inline={true}>
              <label
                id="CardImagingResultUX-label-34"
                style={{fontSize: "1.1rem", color: "#2185D0"}}>
                {props.selectedOrder?.name_code|| "-"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-21"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-28"
              inline={true}
              width={4}>
              <label
                id="CardImagingResultUX-label-40"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Order No.:" : "หมายเลขสั่งซื้อ:"}
              </label>
              <label
                id="CardImagingResultUX-label-41"
                style={{fontWeight: "normal"}}>
                {props.selectedOrder?.order_number|| "-"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-35"
              inline={true}
              width={5}>
              <label
                id="CardImagingResultUX-label-42"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Order date/time:" : "วันที่/เวลาสั่งซื้อ :"}
              </label>
              <label
                id="CardImagingResultUX-label-43"
                style={{fontWeight: "normal"}}>
                {props.selectedOrder?.created|| "-"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-36"
              inline={true}
              width={4}>
              <label
                id="CardImagingResultUX-label-44"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Accession No. :" : "หมายเลขประจำตัวผู้เข้าใช้ :"}
              </label>
              <label
                id="CardImagingResultUX-label-45"
                style={{fontWeight: "normal", wordBreak: "break-all"}}>
                {props.selectedOrder?.accession_id || "-"}
              </label>
              <div
                id="CardImagingResultUX-div-104">
                {props.iconPacs}
              </div>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-37"
              inline={true}
              style={{justifyContent: "flex-end", padding: 0}}
              width={3}>
              <label
                id="CardImagingResultUX-label-46"
                style={{marginRight: "0.5rem", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Status:" : "สถานะ:"}
              </label>
              <Label
                id="CardImagingResultUX-Label-48"
                style={{minWidth: "max-content", backgroundColor: props.statusDetail?.color || "", color: !!props.statusDetail?.color ? "white" : ""}}>
                {!!props.statusDetail?.label ? props.statusDetail?.label : "-"}
              </Label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-22"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-29"
              inline={true}
              width={4}>
              <label
                id="CardImagingResultUX-label-49"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Order department:" : "แผนกสั่งซื้อ :"}
              </label>
              <label
                id="CardImagingResultUX-label-50"
                style={{fontWeight: "normal"}}>
                {props.divisionName || "-"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-38"
              inline={true}
              width={5}>
              <label
                id="CardImagingResultUX-label-51"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Careprovider:" : "ผู้ดูแล:"}
              </label>
              <label
                id="CardImagingResultUX-label-52"
                style={{fontWeight: "normal"}}>
                {props.selectedOrder?.care_provider || "-"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-39"
              inline={true}
              width={6}>
              <label
                id="CardImagingResultUX-label-53"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "Radiologist:" : "รังสีแพทย์:"}
              </label>
              <label
                id="CardImagingResultUX-label-54"
                style={{fontWeight: "normal"}}>
                {props.selectedOrder?.radiologist || "-"}
              </label>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-97"
              inline={true}
              style={{padding: 0}}>
              <div
                id="CardImagingResultUX-div-133">
                {props.buttonPrintReport}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-23"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-30"
              inline={true}>
              <label
                id="CardImagingResultUX-label-55">
                {props.languageUX === "en" ? "Request detail :" : "รายละเอียดการขอ :"}
              </label>
              <label
                id="CardImagingResultUX-label-57">
                {!props.locationsName && !props.selectedOrder?.note ? "-" : `${props.locationsName} ${props.selectedOrder?.note || ""}`}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-24"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-31"
              inline={true}>
              <label
                id="CardImagingResultUX-label-56">
                {props.languageUX === "en" ? "Execution comment :" : "ความคิดเห็นในการดำเนินการ :"}
              </label>
              <label
                id="CardImagingResultUX-label-58">
                {props.executionNote || "-"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-105"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-106"
              inline={true}>
              <label
                id="CardImagingResultUX-label-107">
                {props.languageUX === "en" ? "Principal Diagnosis :" : "การวินิจฉัยหลัก:"}
              </label>
              <label
                id="CardImagingResultUX-label-108">
                {!!props.principalDiagnosis?.icd_code ? `[${props.principalDiagnosis?.icd_code}] ${props.principalDiagnosis?.icd_term}` : "-"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            className="--override-disabled"
            id="CardImagingResultUX-FormGroup-109"
            inline={true}
            style={{backgroundColor: "#e5f4ff", padding: "0.75rem"}}>
            <FormField
              id="CardImagingResultUX-FormField-111"
              inline={true}
              width="10">
              <div
                className="label-suspected-diagnosis"
                id="CardImagingResultUX-div-127"
                style={{width: "190px"}}>

                <label
                  id="CardImagingResultUX-label-128">
                  {props.languageUX === "en" ? "Suspected Diagnosis" : "การวินิจฉัยที่น่าสงสัย"}
                </label>
                <label
                  id="CardImagingResultUX-label-129"
                  style={{color:"red"}}>
                  *
                </label>
              </div>
              <div
                id="CardImagingResultUX-div-117"
                style={{width: "100%", marginRight: "0.75rem"}}>
                {props.principalDiagLabel}
              </div>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-112"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.imagingItemDetail?.extra?.out_time || false}
                id="CardImagingResultUX-Checkbox-118"
                label={props.languageUX === "en" ? "Part-time" : "นอกเวลา"}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-113"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.imagingItemDetail?.is_emergency|| false}
                id="CardImagingResultUX-Checkbox-119"
                label={props.languageUX === "en" ? "Emergency" : "ภาวะฉุกเฉิน"}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-114"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.imagingItemDetail?.extra?.secret|| false}
                id="CardImagingResultUX-Checkbox-120"
                label={props.languageUX === "en" ? "conceal" : "ปกปิด"}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-124"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.imagingItemDetail?.extra?.lawsuit || false}
                id="CardImagingResultUX-Checkbox-125"
                label={props.languageUX === "en" ? "Litigation" : "คดีความ"}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-115"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.imagingItemDetail?.extra?.repeat_medication|| false}
                id="CardImagingResultUX-Checkbox-121"
                label={props.languageUX === "en" ? "Repeat Medication" : "การใช้ยาซ้ำ"}>
              </Checkbox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-59"
            inline={true}
            style={{marginBottom: "0.5rem"}}>
            <FormField
              id="CardImagingResultUX-FormField-61"
              inline={true}>
              <label
                id="CardImagingResultUX-label-63">
                {props.languageUX === "en" ? "Result" : "ผลลัพธ์"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-60"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-62"
              inline={true}
              width={16}>
              <TextArea
                id="CardImagingResult-TextArea-Result"
                name="result"
                onChange={props.onChangeValue}
                readOnly={props.readOnly || false}
                rows="10"
                style={{opacity: 1}}
                value={props.reportDetail?.result || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-65"
            inline={true}
            style={{marginBottom: "0.5rem"}}>
            <FormField
              id="CardImagingResultUX-FormField-67"
              inline={true}>
              <label
                id="CardImagingResultUX-label-69">
                {props.languageUX === "en" ? "Impression" : "ความประทับใจ"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-66"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-68"
              inline={true}
              width={16}>
              <TextArea
                id="CardImagingResult-TextArea-Impression"
                name="impression"
                onChange={props.onChangeValue}
                readOnly={props.readOnly || false}
                rows="10"
                style={{opacity: 1}}
                value={props.reportDetail?.impression || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-71"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-72"
              inline={true}
              width={6}>
              <label
                id="CardImagingResultUX-label-74"
                style={{minWidth: "155px"}}>
                {props.languageUX === "en" ? "Result summary" : "สรุปผล"}
              </label>
              <Dropdown
                disabled={props.readOnly || false}
                fluid={true}
                id="CardImagingResult-Dropdown-ResultSummary"
                name="result_summary"
                onChange={props.onChangeValue}
                options={props.resultSummaryOptions || []}
                search={true}
                selection={true}
                style={{width: "100%",opacity: 1}}
                value={props.reportDetail?.result_summary || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-73"
              inline={true}
              style={{display: props.showEditReason? "":"none"}}
              width={10}>
              <div
                id="CardImagingResultUX-div-79"
                style={{display: "flex"}}>

                <label
                  id="CardImagingResultUX-label-80"
                  style={{minWidth: "max-content", fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Edit reason" : "แก้ไขเหตุผล"}
                </label>
                <label
                  id="CardImagingResultUX-label-81"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
              <Input
                id="CardImagingResult-Input-EditReason"
                name="edit_reason"
                onChange={props.onChangeValue}
                style={{opacity: 1}}
                value={props.reportDetail?.edit_reason || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingResultUX-FormGroup-82"
            inline={true}>
            <FormField
              id="CardImagingResultUX-FormField-83"
              inline={true}
              width={6}>
              <label
                id="CardImagingResultUX-label-86"
                style={{minWidth: "155px", display: "none"}}>
                {props.languageUX === "en" ? "Doctor's fee for reading Imaging results" : "ค่าแพทย์อ่านผล Imaging"}
              </label>
              <Input
                disabled={props.readOnly || false}
                fluid={true}
                id="CardImagingResultUX-Input-87"
                name="doctor_summary_result"
                onChange={props.onChangeValue}
                style={{width: "100%", opacity: 1, display: "none"}}
                value={props.reportDetail?.doctor_summary_result|| ""}>
              </Input>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-84"
              inline={true}
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-85"
              inline={true}
              style={{display: props.showApprove || props.showEdit ? "none":"none"}}>
              <Input
                id="CardImagingResult-Input-Username"
                name={props.showApprove || props.showEdit ? "username":""}
                onChange={props.onChangeValue}
                placeholder={props.showApprove || props.showEdit ? "Username":""}
                ref={(ref: any)=>ref && (ref.inputRef.current.style.border="1px solid rgb(200 197 197)")}
                style={{width: "150px"}}
                value={props.reportDetail?.username|| ""}>
              </Input>
            </FormField>
            <FormField
              className="required"
              id="CardImagingResultUX-FormField-88"
              inline={true}
              style={{display: props.showApprove || props.showEdit ? "flex":"none", alignItems: "center"}}>
              {}
              <label
                id="CardImagingResultUX-label-134">
                {props.languageUX === "en" ? "Password" : "รหัสผ่าน"}
              </label>
              <div
                id="CardImagingResultUX-div-135">
                {props.inputPassword}
              </div>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-89"
              style={{display: props.showEdit? "":"none"}}>
              <div
                id="CardImagingResultUX-div-98">
                {props.buttonEdit}
              </div>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-90"
              style={{display:  !props.showApprove? "none":""}}>
              <div
                id="CardImagingResultUX-div-99">
                {props.buttonApprove}
              </div>
            </FormField>
            <FormField
              id="CardImagingResultUX-FormField-91"
              style={{display:  "none"}}>
              <div
                id="CardImagingResultUX-div-100"
                style={{display: "none"}}>
                {props.buttonCancel}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}

CardImagingResultUX.displayName = "CardImagingResultUX";
export default React.memo(CardImagingResultUX)

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 16:56:12 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-1"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.5rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-4"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResult-Div-ImagingOrderListScreen"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการสั่งซื้อการถ่ายภาพ",
          "valueEN": "Imaging Order List"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", fontWeight: \"bold\", padding: \"2.5px 0\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 15,
      "name": "Table",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.imagingOrderList || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "code",
          "value": "`Orderdate/Time,Order No.,Imaging Type,Request,Item Status,Careprovider,Radiologistt${ props.hideColumnResult ? \"\" : \",Result\"},Log`"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Table-15"
        },
        "keys": {
          "type": "code",
          "value": "`datetime,order_no,type, request, order_status, doctor_name,radiologist${props.hideColumnResult ? \"\" : \",result\"}, log`"
        },
        "minRows": {
          "type": "code",
          "value": "11"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: !!props.selectedOrder? \"195px\": props.tableHeight? props.tableHeight :\"calc(100vh - 14rem)\"}"
        },
        "widths": {
          "type": "code",
          "value": "`120,120,^120,^250,^100,^120,^120${props.hideColumnResult ? \"\" : \",70\"},70`"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "`ui form ${props.readOnly ? \"--override-disabled\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\", display: !!props.selectedOrder?\"\":\"none\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "การป้อนผลลัพธ์การถ่ายภาพ",
          "valueEN": "Imaging Result Entry"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.group_name|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", color: \"#2185D0\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.name_code|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-34"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", color: \"#2185D0\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{justifyContent: \"flex-end\", padding: 0}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขสั่งซื้อ:",
          "valueEN": "Order No.:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.order_number|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-41"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่/เวลาสั่งซื้อ :",
          "valueEN": "Order date/time:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.created|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-43"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขประจำตัวผู้เข้าใช้ :",
          "valueEN": "Accession No. :"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.accession_id || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-45"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", wordBreak: \"break-all\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ:",
          "valueEN": "Status:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Label",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "!!props.statusDetail?.label ? props.statusDetail?.label : \"-\""
        },
        "color": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Label-48"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", backgroundColor: props.statusDetail?.color || \"\", color: !!props.statusDetail?.color ? \"white\" : \"\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกสั่งซื้อ :",
          "valueEN": "Order department:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionName || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ดูแล:",
          "valueEN": "Careprovider:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.care_provider || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-52"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "รังสีแพทย์:",
          "valueEN": "Radiologist:"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedOrder?.radiologist || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-54"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการขอ :",
          "valueEN": "Request detail :"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "ความคิดเห็นในการดำเนินการ :",
          "valueEN": "Execution comment :"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "!props.locationsName && !props.selectedOrder?.note ? \"-\" : `${props.locationsName} ${props.selectedOrder?.note || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.executionNote || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ผลลัพธ์",
          "valueEN": "Result"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "TextArea",
      "parent": 62,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResult-TextArea-Result"
        },
        "name": {
          "type": "value",
          "value": "result"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.result || \"\""
        }
      },
      "seq": 64,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ความประทับใจ",
          "valueEN": "Impression"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "TextArea",
      "parent": 68,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResult-TextArea-Impression"
        },
        "name": {
          "type": "value",
          "value": "impression"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.impression || \"\""
        }
      },
      "seq": 70,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-71"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showEditReason? \"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปผล",
          "valueEN": "Result summary"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-74"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"155px\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Dropdown",
      "parent": 72,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResult-Dropdown-ResultSummary"
        },
        "name": {
          "type": "value",
          "value": "result_summary"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.resultSummaryOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.result_summary || \"\""
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Input",
      "parent": 73,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResult-Input-EditReason"
        },
        "name": {
          "type": "value",
          "value": "edit_reason"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.edit_reason || \"\""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขเหตุผล",
          "valueEN": "Edit reason"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"bold\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showApprove || props.showEdit ? \"none\":\"none\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "ค่าแพทย์อ่านผล Imaging",
          "valueEN": "Doctor's fee for reading Imaging results"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-86"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"155px\", display: \"none\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Input",
      "parent": 83,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Input-87"
        },
        "name": {
          "type": "value",
          "value": "doctor_summary_result"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", opacity: 1, display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.doctor_summary_result|| \"\""
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 82,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showApprove || props.showEdit ? \"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-89"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showEdit? \"\":\"none\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-90"
        },
        "style": {
          "type": "code",
          "value": "{display:  !props.showApprove? \"none\":\"\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-91"
        },
        "style": {
          "type": "code",
          "value": "{display:  \"none\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "Input",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResult-Input-Username"
        },
        "name": {
          "type": "code",
          "value": "props.showApprove || props.showEdit ? \"username\":\"\""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "placeholder": {
          "type": "code",
          "value": "props.showApprove || props.showEdit ? \"Username\":\"\""
        },
        "ref": {
          "type": "code",
          "value": "(ref: any)=>ref && (ref.inputRef.current.style.border=\"1px solid rgb(200 197 197)\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\"}"
        },
        "type": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.reportDetail?.username|| \"\""
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEdit"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonApprove"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCancel"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-101"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-102"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Icon",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Icon-103"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.iconPacs"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยหลัก:",
          "valueEN": "Principal Diagnosis :"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "code",
          "value": "!!props.principalDiagnosis?.icd_code ? `[${props.principalDiagnosis?.icd_code}] ${props.principalDiagnosis?.icd_term}` : \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-108"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormGroup",
      "parent": 17,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormGroup-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#e5f4ff\", padding: \"0.75rem\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "10"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.principalDiagLabel"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"0.75rem\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Checkbox",
      "parent": 112,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.imagingItemDetail?.extra?.out_time || false"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Checkbox-118"
        },
        "label": {
          "type": "value",
          "value": "นอกเวลา",
          "valueEN": "Part-time"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Checkbox",
      "parent": 113,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.imagingItemDetail?.is_emergency|| false"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Checkbox-119"
        },
        "label": {
          "type": "value",
          "value": "ภาวะฉุกเฉิน",
          "valueEN": "Emergency"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Checkbox",
      "parent": 114,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.imagingItemDetail?.extra?.secret|| false"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Checkbox-120"
        },
        "label": {
          "type": "value",
          "value": "ปกปิด",
          "valueEN": "conceal"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Checkbox",
      "parent": 115,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.imagingItemDetail?.extra?.repeat_medication|| false"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Checkbox-121"
        },
        "label": {
          "type": "value",
          "value": "การใช้ยาซ้ำ",
          "valueEN": "Repeat Medication"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Checkbox",
      "parent": 124,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.imagingItemDetail?.extra?.lawsuit || false"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-Checkbox-125"
        },
        "label": {
          "type": "value",
          "value": "คดีความ",
          "valueEN": "Litigation"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "label-suspected-diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{width: \"190px\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยที่น่าสงสัย",
          "valueEN": "Suspected Diagnosis"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-128"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintReport"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผ่าน",
          "valueEN": "Password"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-label-134"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputPassword"
        },
        "id": {
          "type": "value",
          "value": "CardImagingResultUX-div-135"
        }
      },
      "seq": 135,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardImagingResultUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
